import { STANDARD_EASING } from "@/shared/constants/motion";

export const YEATIES_CONSENT_CHECKBOX_LABEL = "Bénéficier de notre programme avantages « Mes Yeaties ».";

export const YEATIES_ACCEPTED_TITLE = "Carte activée, Mes Yeaties aussi.";
export const YEATIES_ACCEPTED_MESSAGE = "Dès votre prochain achat chez une enseigne partenaire, vos yeaties s'accumulent. Bonne découverte !";

export const YEATIES_REFUSED_TITLE = "Mes Yeaties reste désactivé";
export const YEATIES_REFUSED_MESSAGE = "Vos achats chez nos enseignes partenaires ne vous rapporteront ni yeaties ni chèque pour la boutique Yeati.";
export const YEATIES_REFUSED_CHANGE_OF_MIND = "Vous pouvez changer d'avis à tout moment dans les autorisations de votre profil.";

const motionTransition = (duration: number, delay = 0) => ({ duration, delay, ease: STANDARD_EASING });

// Only transform, opacity and pathLength move, and nothing springs: the outcome
// should read as a calm confirmation, not as a celebration.
export const YEATIES_CONSENT_MOTION = {
  checkDraw: motionTransition(0.4),
  refusedPanel: motionTransition(0.2, 0.2),
  reducedFade: motionTransition(0.15),
} as const;
